<template>
  <div>
    <b-row>
      <h2>{{ $t("checklist.form.edit") + " " + $t("sidebar.costCenter") }}</h2>
    </b-row>

    <success-fade-alert ref="alertSuccess" :msg="alert.success" />
    <fade-alert-danger ref="alertDanger" :msg="alert.error" />

    <b-row>
      <b-button @click="voltar()" size="sm">
        {{ $t("geral.back") }}
      </b-button>
    </b-row>

    <div style="margin-top: 10px">
      <b-row>
        <b-col lg="6" md="6" sm="6">
          <CostCenter :model="model" :modelstate="modelstate" />
        </b-col>
      </b-row>
    </div>

    <b-row style="margin-top: 40px">
      <b-button @click="edit" size="sm">
        {{ $t("geral.save") }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
    CostCenter: () =>
      import("@/components_rms/System/CostCenter/costCenter.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      modelstate: [],
      alert: {
        error: "",
        success: "Registro Editado com sucesso",
      },
      idCostCenter: this.$route.params.id,
      model: {
        code: null,
        name: null,
        parentCostCenterId: null,
      },
    };
  },
  mounted() {
    this.getCostCenter();
  },
  methods: {
    edit() {
      this.modelstate = [];
      let obj = {
        code: this.model.code,
        name: this.model.name,
        parentCostCenterId: this.model.parentCostCenterId,
      };
      this.$apiScheduler
        .put(`/costCenter/edit/${this.idCostCenter}`, obj)
        .then((response) => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.alertDanger.show();
          } else {
            this.$refs.alertSuccess.show();
          }
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    getCostCenter() {
      this.$apiScheduler
        .get(`/costCenter/get/${this.idCostCenter}`)
        .then((response) => {
          this.model.code = response.data.code;
          this.model.name = response.data.name;
          this.model.parentCostCenterId = response.data.parentCostCenterId;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    voltar() {
      this.$router.go(-1);
    },
  },
};
</script>